import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DraggableDirective } from '@shared/directive/draggable';
import { VibrationRecord } from '@shared/models/vibration-record';
import { VibrationsRecordService } from '@shared/services/records/vibrations-record.service';
import { FonctionsService } from '@shared/services/utilities/fonctions.service';

@Component({
  selector: 'app-notes-modal',
  imports: [CommonModule,
    FormsModule,
    TranslateModule,
    DraggableDirective],
  templateUrl: './notes-modal.component.html',
  styleUrl: './notes-modal.component.scss'
})
export class NotesModalComponent implements OnInit {
  note1: string = '';
  note2: string = '';
  note3: string = '';
  siteId: number;
  constructor(
    public dialogRef: MatDialogRef<NotesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private vibrationRecordService: VibrationsRecordService,
    private fonctionsService: FonctionsService

  ) { }
  ngOnInit(): void {

    this.note1 = this.data.record.recordMetadata?.note1;
    this.note2 = this.data.record.recordMetadata?.note2;
    this.note3 = this.data.record.recordMetadata?.note3;
    this.siteId = this.data.siteId;
    console.log(this.data);

  }
  onConfirm(): void {
    let record: VibrationRecord = {
      information: {
        currentURL: window.location.href,
        regionName: '',
        siteName: '',
        controlPointName: null,
      },
      vibrationRecord: this.data.record
    }
    record.vibrationRecord.recordMetadata.note1 = this.note1;
    record.vibrationRecord.recordMetadata.note2 = this.note2;
    record.vibrationRecord.recordMetadata.note3 = this.note3;
    console.log(record);

    this.vibrationRecordService.updateRecord(this.siteId, record.vibrationRecord.id.toString(), record).subscribe({
      next: () => {
        this.fonctionsService.launch_toast(true, 'Notes updated successfully');
        this.dialogRef.close(false);
      },
      error: (err: any) => {
      }
    });


  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
